import React from "react";
import { Box, Tabs, Tab, makeStyles } from "@material-ui/core";

const useStyle = () => ({
  boxStyle: { display: "flex", justifyContent: "center" },
  tabStyle: {
    textTransform: "none",
    fontWeight: 400,
    fontSize: 14,
    //borderRadius: 32,
  },
});

const styled = makeStyles((theme) => ({
  tabs: {
    borderRadius: 32,
    backgroundColor: "#FFF8FB",
    color: "#EB078E",
  },
  tab: {
    minWidth: 100, // a number of your choice
    width: 100, // a number of your choice
  },
}));

export default function CustomTab({ config, tabIndex, onTabChange }) {
  const styles = useStyle();
  const clases = styled();
  return (
    <Box style={styles.boxStyle}>
      <Tabs
        variant="fullWidth"
        value={tabIndex}
        onChange={onTabChange}
        indicatorColor="secondary"
        textColor="secondary"
        className={clases.tabs}
      >
        {config.map(({ action, label }) => (
          <Tab
            style={styles.tabStyle}
            onClick={action}
            label={label}
            key={label}
            classes={{ root: clases.tab }}
          />
        ))}
      </Tabs>
    </Box>
  );
}
